var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(
      this.$store.state.development.developmentName === null &&
        this.$store.state.isLoggedIn
    )?_c('div',[_c('Development')],1):_vm._e(),_c('HomePage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }